"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useInvoiceItemStyle = ({ type, selected }) => {
    const theme = (0, material_1.useTheme)();
    const colorSecondary = { color: '#eed7ff' };
    const colorHighEmphasis = { color: theme.qlub.palette.onSurfaceColors.highEmphasis };
    const colorMediumEmphasis = { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis };
    const colorLowEmphasis = { color: theme.qlub.palette.onSurfaceColors.disabled };
    const colorBackground = { color: '#f9f9f9' };
    const colorGreen = { color: '#1c8659' };
    const currencyStyle = {
        fontSize: '10px',
        marginRight: '2px',
        "html[dir='rtl']": {
            marginLeft: '2px',
        },
    };
    const splitPriceContainer = {
        alignItems: 'center',
        justifyContent: 'space-between',
        '>div': {
            '&:last-of-type': {
                width: 'max-content',
                padding: '2px',
                margin: 'auto 2px auto 16px',
                "html[dir='rtl'] &": {
                    margin: 'auto 16px auto 2px',
                },
            },
        },
    };
    const invoiceItemTitle = {
        fontSize: '1em',
        fontWeight: '400',
    };
    const invoiceItem = Object.assign(Object.assign(Object.assign({ alignItems: 'center' }, (type !== 'split' && {
        padding: '0.5rem 0px 0.5rem',
    })), ((type === 'split' || type === 'exploded-receipt-item') && Object.assign({ display: 'flex', padding: '0.8rem 0.8rem 0px 1.2rem', backgroundColor: 'white', minHeight: '4rem', maxHeight: '4rem', borderRadius: '100px', boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.1)', color: selected ? theme.palette.grey[500] : 'inherit' }, (type === 'exploded-receipt-item' && {
        boxShadow: 'none',
        minHeight: 'unset',
        maxHeight: 'unset',
    })))), { '.rtl-support': {
            display: 'inline-block',
        }, '.itemExtraStyle': {
            width: '96px',
            paddingLeft: '4px',
        }, '& .itemValue': Object.assign(Object.assign(Object.assign({}, (type === 'split' && {
            position: 'relative',
        })), { '>span': {
                display: 'inline-block',
            } }), (type === 'split' &&
            selected && {
            '&::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                height: '1px',
                backgroundColor: theme.palette.grey[500],
                pointerEvents: 'none',
            },
        })), '&.styleStrike': {
            '& .itemValue': {
                textDecorationLine: 'line-through',
            },
        }, '&.styleStrikeLabel': {
            '&:first-of-type': {
                textDecorationLine: 'line-through',
            },
        }, '>div.priceContainer': Object.assign({ display: 'flex', '>div': {
                '&:last-of-type': {
                    minWidth: '60px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                },
            } }, (type === 'split' && splitPriceContainer)), '>div': Object.assign(Object.assign({ color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', textDecorationLine: 'inherit', verticalAlign: 'middle' }, (type === 'exploded-receipt-item' && {
            padding: '0.2rem 0px 0.2rem',
        })), { borderBottom: 'none', '&:first-of-type': {
                display: 'flex',
                alignItems: 'center',
            }, '& .noWrap': {
                whiteSpace: 'nowrap',
            }, '& .dinerFeeTooltip': {
                alignItems: 'center',
            }, '& .value': {
                width: '56px',
                '& .split': {
                    fontSize: ' 0.9em',
                },
            }, '& .altValue': {
                color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                fontSize: '12px',
                paddingRight: '0.5rem',
                display: 'flex',
                alignItems: 'center',
            }, '&.newAlt': {
                width: '48px',
                color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                fontSize: '12px',
                padding: '4px 0 0 2rem',
                display: 'inline-block',
            }, '& .itemExtra': {
                width: '96px',
            }, '&.billTitle': {
                maxWidth: '70%',
                flex: '1 1',
                '>span': {
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: '-webkit-box !important',
                    '-webkit-line-clamp': '2',
                    '-webkit-box-orient': 'vertical',
                    whiteSpace: 'normal',
                },
            }, '& .iconContainer': {
                display: 'inline-flex',
                width: 'max-content',
                height: '24px',
                margin: '0 8px 0 0',
                alignItems: 'center',
                justifyContent: 'center',
                '& svg': {
                    height: '24px',
                    width: '24px',
                },
                '& .splitItemQty': {
                    display: 'inline-flex',
                    backgroundColor: '#f9f9f9',
                    height: '24px',
                    width: '24px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: theme.qlub.palette.onSurfaceColors.highEmphasis,
                    fontSize: '12px',
                    lineHeight: '1em',
                    borderRadius: '24px',
                },
                '& .itemQty': {
                    display: 'inline-flex',
                    backgroundColor: theme.qlub.palette.dim.main,
                    height: '24px',
                    width: 'max-content',
                    padding: '0 8px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: theme.qlub.palette.onSurfaceColors.highEmphasis,
                    fontSize: '12px',
                    lineHeight: '1em',
                    borderRadius: '24px',
                    '& .itemQtyTopping': {
                        backgroundColor: 'transparent',
                    },
                },
                "html[dir='rtl'] &": {
                    margin: '0 0 0 8px',
                },
            } }), '&.newRow': Object.assign({ '@keyframes fadeBg': {
                from: {
                    backgroundColor: theme.qlub.palette.iris_light.main,
                },
                to: {
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                },
            }, animationName: 'fadeBg', animationDuration: '10s', animationIterationCount: '1' }, (type !== 'split' && {
            '&:first-child': {
                position: 'relative',
            },
        })), '&.topping': {
            padding: ' 0 0 8px 0',
            '.toppingAltValue': {
                padding: '0 0.5rem 0 0 !important',
            },
            '>div': {
                minHeight: '20px',
                padding: '0 4px 0 !important',
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                '& .iconContainer': {
                    '& svg': {
                        height: '20px',
                        width: '20px',
                    },
                    '& .itemQty': {
                        height: '20px',
                        width: '24px',
                        fontSize: '10px',
                        lineHeight: '1em',
                        background: 'unset',
                        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                    },
                },
                "html[dir='rtl'] &": {
                    '&:first-of-type': {
                        paddingLeft: '24px !important',
                    },
                },
                '&:first-of-type': {
                    padding: '0 4px 0 24px !important',
                },
                '&:last-of-type': {
                    minWidth: '60px',
                    justifyContent: 'flex-end',
                    padding: '0 !important',
                },
            },
        }, '&.paid': {
            backgroundColor: theme.qlub.palette.iris_light.main,
            color: '#363636',
        }, '&.MuiTableRow-footer': {
            '&:first-of-type': {
                '& td': {
                    paddingTop: '16px !important',
                },
            },
        }, '& .indicator': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
        } });
    const colorPrimary = {
        color: theme.qlub.palette.iris.main,
    };
    const styleTitleMedium = {
        fontWeight: 500,
        fontSize: '16px',
        '& td': {
            '&.altValue': {
                fontSize: '14px',
            },
        },
    };
    const styleTitleSmall = {
        fontWeight: 500,
        fontSize: '14px',
        '& td': {
            '&.altValue': {
                fontSize: '12px',
            },
        },
    };
    const styleBodyMedium = {
        fontSize: '14px',
        '&.altValue': {
            fontSize: '12px',
        },
    };
    const styleBodySmall = {
        fontSize: '14px',
        '& td': {
            '&.altValue': {
                fontSize: '12px',
            },
        },
    };
    const styleStrike = {
        '& .itemValue': {
            textDecorationLine: 'line-through',
        },
    };
    const invoiceItemPrefixIcon = Object.assign(Object.assign(Object.assign({ fontSize: '14px' }, (type === 'exploded-receipt-item' && {
        fontSize: '12px',
    })), { marginLeft: '8px' }), (selected && {
        color: theme.palette.grey[400],
    }));
    const invoiceItemPrefixIconContainer = {
        marginRight: '8px',
    };
    return {
        invoiceItemTitle,
        invoiceItem,
        colorPrimary,
        colorSecondary,
        colorHighEmphasis,
        colorMediumEmphasis,
        colorLowEmphasis,
        colorBackground,
        colorGreen,
        styleTitleMedium,
        styleTitleSmall,
        styleBodyMedium,
        styleBodySmall,
        styleStrike,
        currencyStyle,
        splitPriceContainer,
        invoiceItemPrefixIcon,
        invoiceItemPrefixIconContainer,
    };
};
exports.default = useInvoiceItemStyle;
